import { useEffect } from 'react'
import HeroSection from '@/components/Home/HeroSection'
import AboutSection from '@/components/Home/AboutSection'
import CommunitySection from '@/components/Home/CommunitySection'
import EventsSection from '@/components/Home/EventsSection'
import TestimonialsSection from '@/components/Home/TestimonialsSection'
import FaqSection from '@/components/Home/FaqSection'
import CtaSection from '@/components/Home/CtaSection'

function HomePage() {
  useEffect(() => {
    document.getElementById(window.location.hash.slice(1))?.scrollIntoView()
  }, [])

  return (
    <div className="ac-home">
      <HeroSection />
      <AboutSection />
      <CommunitySection />
      <EventsSection />
      <TestimonialsSection />
      <FaqSection />
      <CtaSection />
    </div>
  )
}

export default HomePage
